import { Stack } from "@mui/material";
import { useEffect, useRef } from "react";
import { renderBarcodeToCanvas } from "../../utils/zplBarcode";

export const Barcode = ({
  value = "Empty",
  format = "CODE128",
  height = 60,
  ...rest
}) => {
  const canvasRef = useRef();

  useEffect(() => {
    const containerWidth = canvasRef.current.parentElement.offsetWidth;
    canvasRef.current.width = containerWidth;
    canvasRef.current.height = height;

    renderBarcodeToCanvas(canvasRef.current, value, format, {
      width: containerWidth,
      height,
      ...rest,
    });
  }, [value, format, height, rest]);

  return (
    <Stack
      sx={{
        width: "100%",
        height: `${height}px`,
        alignItems: "center",
      }}
    >
      <canvas
        ref={canvasRef}
        style={{ width: "100%", height: `${height}px` }}
      />
    </Stack>
  );
};

export default Barcode;
